/**
 * NovaQuantis Design System Constants
 * Based on design guidelines in src/design/guidelines.md
 */

// Company Information
export const COMPANY_NAME = 'NovaQuantis';
export const COMPANY_NAME_SHORT = 'NovaQuantis';

// Color Palette
export const COLORS = {
  // Primary Accents
  primaryBlue: '#25B4E0',
  primaryOrange: '#F7941D',
  portfolioGreen: '#2EE66B',
  benchmarkLine: '#7B8798',
  
  // Backgrounds
  darkBackground: '#0D111E',
  white: '#FFFFFF',
  
  // Text Colors
  darkGrayText: '#333333',
  mediumGrayText: '#666666',
  
  // UI Elements
  lightGrayBorder: '#E0E0E0',
} as const;

// Typography
export const FONTS = {
  heading: "'Montserrat', 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  body: "'Roboto', 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
} as const;

// Logo Paths (relative to src directory)
export const LOGO_PATHS = {
  full: '/design/Logo full.jpg',
  icon: '/design/Logo.png',
} as const;

